export default __webpack_public_path__ + "static/media/building.4ac7d947.svg";